import { CatchBoundary, Outlet, useLocation } from '@tanstack/react-router'
import { Suspense } from 'react'

import { AnalyticsContainer } from '@/features/analytics/AnalyticsContainer'
import { ComplianceContainer } from '@/features/compliance/ComplianceContainer'
import { Debug } from '@/features/debug'
import { DialogDispatcherContainer } from '@/features/dialogs/dispatcher/DialogDispatcherContainer'
import { ErrorComponent } from '@/features/errors/ErrorComponent'
import { AppLayout } from '@/ui/layouts/app-layout/AppLayout'
import { FallbackLayout } from '@/ui/layouts/FallbackLayout'

export function RootRoute() {
  const location = useLocation()

  return (
    <Suspense fallback={<FallbackLayout />}>
      <AppLayout>
        <CatchBoundary getResetKey={() => location.href} errorComponent={ErrorComponent}>
          <Outlet />
          <DialogDispatcherContainer />
          <ComplianceContainer />
          <AnalyticsContainer />
        </CatchBoundary>
        {import.meta.env.VITE_DEV_DEBUG === '1' && <Debug />}
      </AppLayout>
    </Suspense>
  )
}
